import axios from "axios";
import vm from "@/main";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "https://sales-demo-v9.pointr.cloud/api/v9"
});

export default class LoginService {
  static async getToken(input) {
    try {
      if (vm) {
        vm.$store.commit("ADD_BACKGROUND_LOADING_REQUEST");
      }
      const response = await axiosInstance.post(`identity/auth/token`, input);
      return response?.data;
    } catch (error) {
      throw error?.response?.data;
    } finally {
      if (vm) {
        vm.$store.commit("REMOVE_BACKGROUND_LOADING_REQUEST");
      }
    }
  }

  static async resetPassword(input) {
    try {
      vm.$store.commit("ADD_LOADING_REQUEST");
      const response = await axiosInstance.post(`identity/auth/reset-password`, input);
      return response?.data;
    } catch (error) {
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
  }

  static async forgotPassword(input) {
    try {
      vm.$store.commit("ADD_LOADING_REQUEST");
      const response = await axiosInstance.post(`identity/auth/password`, input);
      return response?.data;
    } catch (error) {
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
  }

  static async logout(input) {
    try {
      await axiosInstance.post(`identity/auth/logout`, input);
    } catch (error) {
      console.warn("Error logging out");
    }
  }
}
